import { HttpClient } from "../common/http-client";
import { Environment } from "../environment/app-settings";
import { ConfirmManualVerificationDefaultMethodResponse, IGetWorkingHoursResponse, SignResponse } from "../models/responses/sing-application.response";
import { ConfirmManualVerificationDefaultMethodDTO, SignApplicationDTO } from "../models/sign-application.model";


//#region SettingService Instance
let instance: ApplicationService
//#endregion

export class ApplicationService {
  private readonly _client: HttpClient;
  private readonly _signApplicationUrlPath = "/application/sign"
  private readonly _confirmManualVerificationDefaultMethodUrlPath = "/application/confirmManualVerificationDefaultMethod"
  private readonly _getWorkingHoursUrlPath = "/application/getWorkingHours"

  constructor() {
      if (instance) { //SINGLETON DESIGN PATTERN
         throw new Error("New instance cannot be created!!")
      }
   
      instance = this;
      this._client = new HttpClient(Environment.apiUrl)
  }

  public async signApplication(sign: SignApplicationDTO): Promise<SignResponse> {
    return (await this._client.post<SignResponse, SignApplicationDTO>(
      this._signApplicationUrlPath,
      sign,
      true,
      undefined,
      { sendFacebookTrackingHeaders: true }
    )).data;
  }

  public async getWorkingHours(): Promise<IGetWorkingHoursResponse> {
    return (await this._client.post<IGetWorkingHoursResponse, {}>(
      this._getWorkingHoursUrlPath,
      {},
      true
    )).data;
  }

  public async confirmManualVerificationDefaultMethod(confirmManual: ConfirmManualVerificationDefaultMethodDTO): Promise<ConfirmManualVerificationDefaultMethodResponse> {
    return (await this._client.post<ConfirmManualVerificationDefaultMethodResponse, ConfirmManualVerificationDefaultMethodDTO>(
      this._confirmManualVerificationDefaultMethodUrlPath,
      confirmManual,
      true
    )).data;
  }
}

let applicationService = Object.freeze(new ApplicationService())//SINGLETON DESIGN PATTERN
export default applicationService;
